export default __webpack_public_path__ + "static/media/out-status.620e7f31.svg";